import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Импорт переводов
import en from "./locales/en/translation.json";
import de from "./locales/de/translation.json";
import ru from "./locales/ru/translation.json";
import uk from "./locales/uk/translation.json";
import fr from "./locales/fr/translation.json";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    ru: { translation: ru },
    uk: { translation: uk },
    fr: { translation: fr },
  },
  lng: localStorage.getItem("language") || "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
